import BaseApi from './baseApi';
import ITransformationsPalletsDestination from '../models/ITransformationsPalletsDestination';
import IAuthentication from '../models/IAuthentication';
export default class TransformationPalletsDestinationApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Transformations");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetTransformationsPalletsDestination(idTransformation: string) : Promise<ITransformationsPalletsDestination[]> {
        let json = this.getJsonReadWithIdTransformation(idTransformation);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var transformationsPalletsDestination: ITransformationsPalletsDestination[] = [];
            transformationsPalletsDestination = response.data as ITransformationsPalletsDestination[];
            return transformationsPalletsDestination;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveTransformationPalletsDestination(transformationPalletDestination: ITransformationsPalletsDestination) : Promise<string> {
        const json = this.getJsonSave(transformationPalletDestination);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateTransformationPalletsDestination(transformationPalletDestination: ITransformationsPalletsDestination) : Promise<boolean> {
        const json = this.getJsonUpdate(transformationPalletDestination);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteTransformationPalletDestination(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteTransformationPalletDestinationByTransformationId(transformationId: string) {
        const json = this.getJsonDeleteByTransformationId(transformationId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDeleteByTransformationId(idTransformation: string) {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "conditions": [{
                "Item1": "transformationsPalletsDestination",
                "Item2": "idTransformation",
                "Item3": "=",
                "Item4": idTransformation
            }],
            "table": "transformationsPalletsDestination"
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "conditions": [{
                "Item1": "transformationsPalletsDestination",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }],
            "table": "transformationsPalletsDestination"
        };
        return json;
    }

    private getJsonSave(transformationPalletDestination: ITransformationsPalletsDestination) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "palletAmount",
                "Item2": transformationPalletDestination.palletAmount
            }, {
                "Item1": "idListPallet",
                "Item2": transformationPalletDestination.idListPallet
            }, {
                "Item1": "idGood",
                "Item2": transformationPalletDestination.idGood
            }, {
                "Item1": "casesPerPallet",
                "Item2": transformationPalletDestination.casesPerPallet
            }, {
                "Item1": "goodsPerCase",
                "Item2": transformationPalletDestination.goodsPerCase
            }, {
                "Item1": "Location",
                "Item2": transformationPalletDestination.location
            }, {
                "Item1": "idTransformation",
                "Item2": transformationPalletDestination.idTransformation
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "transformationsPalletsDestination"
        };
        return json;
    }

    private getJsonUpdate(transformationPalletDestination: ITransformationsPalletsDestination) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "palletAmount",
                "Item2": transformationPalletDestination.palletAmount
            }, {
                "Item1": "idListPallet",
                "Item2": transformationPalletDestination.idListPallet
            }, {
                "Item1": "idGood",
                "Item2": transformationPalletDestination.idGood
            }, {
                "Item1": "casesPerPallet",
                "Item2": transformationPalletDestination.casesPerPallet
            }, {
                "Item1": "goodsPerCase",
                "Item2": transformationPalletDestination.goodsPerCase
            }, {
                "Item1": "Location",
                "Item2": transformationPalletDestination.location
            }, {
                "Item1": "idTransformation",
                "Item2": transformationPalletDestination.idTransformation
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "transformationsPalletsDestination",
            "keyvalue": transformationPalletDestination.id
        };
        return json;
    }

    private getJsonReadWithIdTransformation(idTransformation: string) : any {
        const json = {
            "fields": [{
                "Item1": "transformationsPalletsDestination",
                "Item2": "id"
            }, {
                "Item1": "transformationsPalletsDestination",
                "Item2": "palletAmount"
            }, {
                "Item1": "transformationsPalletsDestination",
                "Item2": "idListPallet"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as palletName"
            }, {
                "Item1": "transformationsPalletsDestination",
                "Item2": "idGood"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "transformationsPalletsDestination",
                "Item2": "casesPerPallet"
            }, {
                "Item1": "transformationsPalletsDestination",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "transformationsPalletsDestination",
                "Item2": "location"
            }, {
                "Item1": "transformationsPalletsDestination",
                "Item2": "idTransformation"
            }],
            "tables": [{
                "Item1": "TransformationsPalletsDestination"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "Goods"
            }],
            "conditions": [{
                "Item1": "TransformationsPalletsDestination",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "TransformationsPalletsDestination",
                "Item2": "idTransformation",
                "Item3": "=",
                "Item4": idTransformation
            }],
            "joins": [{
                "Item1": "TransformationsPalletsDestination",
                "Item2": "idListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "TransformationsPalletsDestination",
                "Item2": "idGood",
                "Item3": "Goods",
                "Item4": "Id"
            }]
        };
        return json;
    }
}
